import { useEffect } from "react";
import capitalize from "lodash/capitalize";
import { anonymousSessionState } from "@web-src/modules/auth/providers/AnonymousSessionProvider/anonymousSessionState";
import api from "./api";

export const useApi = ({
  onError,
}: {
  onError?: (e: {
    status?: number;
    data?: Record<string, unknown>;
    message?: string;
    url?: string;
  }) => void;
}) => {
  useEffect(() => {
    const interceptor = api.interceptors.response.use(undefined, (error) => {
      let message = error.message ? capitalize(error.message) : "";
      if (error.request?.responseURL?.includes("/web/verify-email")) {
        message = "Invalid email or password";
      }

      if (error.request?.status === 401) {
        if (!anonymousSessionState.isAnonymous) {
          message = "Your session expired, please login again";
        }
      }

      if (Array.isArray(error.response?.data?.errors)) {
        message = capitalize(error.response?.data?.errors[0].message);
      }

      if (typeof error.response?.data?.errors === "string") {
        message = capitalize(error.response?.data?.errors.replaceAll("_", " "));
      }
      if (
        !error.config.silentError &&
        !error._isSimulated &&
        // NOTE: temporarily ignore 403 errors
        error.request?.status !== 403 &&
        !(
          [401].includes(error.request?.status) &&
          anonymousSessionState.isAnonymous
        )
      ) {
        onError?.({
          url: error.config.url,
          status: error.response?.status,
          data: error.response?.data || error.message,
          message,
        });
      }
      throw error;
    });

    return () => {
      api.interceptors.response.eject(interceptor);
    };
  }, [onError]);
};
